import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import Avatar from './Avatar';
import MessageBubble from './MessageBubble';

import ChartsLoading from '@/components/loading/ChartsLoading';
// import { Reasoning, ReasoningContent, ReasoningTrigger } from '@/components/ai-elements/reasoning';
// 定义 ref 接口
export interface ChartsRef {
  refresh: () => void;
}

import { useChatContext } from '@/contexts/ChatContext';

const ChatInterface = forwardRef<ChartsRef>((_, ref) => {
  const { messages, setProcessing } = useChatContext();

  setTimeout(() => {
    setProcessing(false);
  }, 3000);

  const refresh = () => {
    console.log('Charts 组件 refresh 被调用');
    setProcessing(true);
    setTimeout(() => {
      setProcessing(false);
    }, 3000);
  };

  // 暴露 refresh 方法给父组件
  useImperativeHandle(ref, () => ({
    refresh
  }));

  return (
    <div className="mx-auto min-h-full max-w-4xl rounded-lg bg-white p-4">
      {/* AI助手欢迎消息 */}

      {messages.map((message, index) => (
        <div key={`message-${index}`}>
          {message.position === 'left' && (
            <div className="mb-4 flex flex-col gap-3">
              <Avatar />
              {message.loading ? (
                <ChartsLoading size="lg" />
              ) : (
                <MessageBubble className="w-full">
                  {message.content
                    ? message.content
                    : '您好，我是您的AI智能投顾助手。我可以帮您分析市场行情、推荐投资产品、制定资产配置方案，以及回答各类投资理财问题。您可以通过底部输入框与我交流。'}
                </MessageBubble>
              )}
            </div>
          )}
          {message.position === 'right' && (
            <div className="mb-4 flex flex-col gap-3">
              <MessageBubble className="w-full" isUser>
                {message.content}
              </MessageBubble>
            </div>
          )}
        </div>
      ))}
    </div>
  );
});

ChatInterface.displayName = 'ChatInterface';

export default ChatInterface;
